import "styles/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactGA from "react-ga4";
import { MainHeader } from "components/headers";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "pages/Home";
import About from "pages/About";
import Overview from "pages/about-us/corporate-info/Overview";
import OurValues from "pages/about-us/corporate-info/OurValues";
import OurBackground from "pages/about-us/corporate-info/OurBackground";
import ListNews from "pages/about-us/news/list";
import { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { MainFooter, SubFooter } from "components/footers";
import Commodity from "pages/personal/deposits/Commodity";
import Commodity2 from "pages/personal/deposits/Commodity2";
import Commodity3 from "pages/personal/deposits/Commodity3";
import Commodity4 from "pages/personal/deposits/Commodity4";
import CurrentAccount from "pages/personal/deposits/CurrentAccount";
import SavingsAccount from "pages/personal/deposits/SavingsAccount";
import DebitCard from "pages/personal/cards/DebitCard";
import ViewNews from "pages/about-us/news/view";
import PromotionNews from "pages/about-us/news/promotion";
import Compliance from "pages/about-us/corporate-governance/Compliance";
import FatcaCrs from "pages/about-us/corporate-governance/FatcaCrs";
import Whistleblow from "pages/about-us/corporate-governance/Whistleblow";
import Disclosure from "pages/about-us/corporate-governance/Disclosure";
import Gold from "pages/personal/wealth/Gold";
import TreatCustomerFairlyCharter from "pages/operations/customer-service/TreatCustomerFairlyCharter";
import ClientCharter from "pages/operations/customer-service/ClientCharter";
import GoldInvest from "pages/personal/wealth/GoldInvest";
import UnitTrust from "pages/personal/wealth/UnitTrust";
import GoldPrice from "pages/operations/customer-service/GoldPrice";
import UnitTrustPrice from "pages/operations/customer-service/UnitTrustPrice";
import TermAndConditions from "pages/TermAndConditions";
import SinarKasih from "pages/personal/wealth/SinarKasih";
import ContactUs from "pages/ContactUs";
import SinarLinkAiman from "pages/personal/wealth/SinarLinkAiman";
import SinarBaraqah from "pages/personal/wealth/SinarBaraqah";
import SinarHealthPlan from "pages/personal/wealth/SinarHealthPlan";
import StructuredProduct from "pages/personal/wealth/StructuedProduct";
import WillWriting from "pages/personal/wealth/WillWriting";
import SafeDepositBox from "pages/personal/wealth/SafeDepositBox";
import VirtualBanking from "pages/personal/VirtualBanking";
import Enquiry from "pages/Enquiry";
import Career from "pages/Career";
import Deposit from "pages/business/treasury/Deposit";
import ForeignExchange from "pages/business/treasury/ForeignExchange";
import CurrentAccountBiz from "pages/business/deposits/CurrentAccountBiz";
import FloatingRate from "pages/business/deposits/FloatingRateTD";
import CommodityMurabahahBiz from "pages/business/deposits/CommodityMurabahahBiz";
import CommodityMurabahahBiz2 from "pages/business/deposits/CommodityMurabahahBiz2";
import Microsite from "pages/Microsite";
import BoardOfDirectors from "pages/about-us/corporate-profile/BoardOfDirectors";
import ShariahBoard from "pages/about-us/corporate-profile/ShariahBoard";
import ViewProfile from "pages/about-us/corporate-profile/ViewProfile";
import PromotionsMain from "pages/personal/promotions/PromotionsMain";
import GlobalMarkets from "pages/business/GlobalMarkets";
import Cashline from "pages/business/financing/Cashline";
import CommodityFinancing from "pages/business/financing/CommodityFinancing";
import StructuredCommodity from "pages/business/financing/StructuredCommodity";
import TradeFinance from "pages/business/financing/tradefinancing/TradeFinance";
import SyndicationFinancing from "pages/business/financing/SyndicationFinancing";
import LetterCredit from "pages/business/financing/tradefinancing/LetterCredit";
import ShippingGuarantee from "pages/business/financing/tradefinancing/ShippingGuarantee";
import BankGuarantee from "pages/business/financing/tradefinancing/BankGuarantee";
import TradeCommodity from "pages/business/financing/tradefinancing/TradeCommodity";
import BillCollection from "pages/business/financing/tradefinancing/BillCollection";
import TermDeposit from "pages/business/deposits/TermDeposit";
import AlrajhiCashBiz from "pages/business/cashmanagement/AlrajhiCashBiz";
import EPayment from "pages/business/cashmanagement/EPayment";
import PrivacyPolicy from "pages/PrivacyPolicy";
import { Maintenance } from "components/maintenance";
import Affluent from "pages/personal/Affluent";
import PersonalFinancing from "pages/personal/financing/PersonalFinancing";
import PersonalFinancingTD from "pages/personal/financing/PersonalFinancingTD";
import PersonalFinancingCCSP from "pages/personal/financing/PersonalFinancingCCSP";
import PersonalFinancingEBS from "pages/personal/financing/PersonalFinancingEBS";
import PersonalFinancingUmrah from "pages/personal/financing/PersonalFinancingUmrah";
import PropertyFinancingHome from "pages/personal/financing/PropertyFinancingHome";
import PropertyFinancingHomeOne from "pages/personal/financing/PropertyFinancingHomeOne";
import ExecutiveManagement from "pages/about-us/corporate-profile/ExecutiveManagement";
import AffluentProposition from "pages/personal/others/AffluentProposition";
import HistoricalTrend from "pages/personal/financing/HistoricalTrend";
import BusinessFinancing from "pages/personal/financing/BusinessFinancing";
import TabContext from "context/TabContext";
import ImportantNoticeDetail from "pages/personal/others/ImportantNoticeDetail";
import Rize from "pages/rize/Rize";
import Rafahia from "pages/personal/cards/Rafahia";
import DigitalBankingOverview from "pages/digitalBanking/DigitalBankingOverview";
import FAQ from "pages/rize/FAQ";
import Promotions from "pages/rize/Promotions";
import SecurityTips from "components/modal/SecurityTips";
import FraudAwareness from "pages/FraudAwareness";
import CashlinePersonal from "pages/personal/financing/CashlinePersonal";
import ForeignExchangeRates from "pages/ForeignExchangeRates";
import InsuredDeposits from "pages/InsuredDeposits";
import NegativeList from "pages/NegativeList";
import Auctions from "pages/Auctions";
import ApplicationForm from "pages/ApplicationForm";
import ATMServices from "pages/services/ATMServices";
import MEPSATMServices from "pages/services/MEPSATMServices";
import ChequeDeposit from "pages/services/ChequeDeposit";
import SMSNotificationAlerts from "pages/services/SMSNotificationAlerts";
import ServiceRequestForm from "pages/services/ServiceRequestForm";
import rize from "assets/images/Rize1_124.jpg";
import FinancialReport from "pages/about-us/financial-report/financial-report";
import ImportantNotices from "pages/operations/ImportantNotices";
import GlobalAlert from "components/alert/GlobalAlert";
import usePageTracking from "utils/usePageTracking";
import Success from "pages/email/Success";
import Failed from "pages/email/Failed";
import Expired from "pages/email/Expired";
import MicrositePF from "pages/microsite-pf/pf";
import MicrositeUmrah from "pages/microsite-pf/pf/indexUmrah";
import MicrositeCCSP from "pages/microsite-pf/pf/indexCCSP";
import MicrositeEBS from "pages/microsite-pf/pf/indexEBS";
import MicrositePFTD from "pages/microsite-pf/pf/indexPFTD";
import ComingSoon from "pages/digitalBanking/coming-soon/ComingSoon";
import PromotionalBanner from "components/modal/PromotionalBanner";
import QrRedirect from "components/qrRedirect/QrRedirect";

function App() {
  const formRef = useRef(null);
  const globalAlertRef = useRef(null);
  const [tab, setTab] = useState(0);
  const [showBanner, setBanner] = useState(false);
  const [showTips, setShowTips] = useState(false);
  const [alertHeight, setAlertHeight] = useState(0);

  // function usePageViews() {
  //   let location = useLocation();
  //   React.useEffect(() => {
  //     ReactGA.send(["pageview", location.pathname]);
  //   }, [location]);
  // }
  usePageTracking();

  useEffect(() => {
    AOS.init();
    ReactGA.initialize("G-D0G3HQLP6R");
  }, []);

  return (
    <TabContext.Provider
      value={{
        tabState: [tab, setTab],
        enquiryFormRef: [formRef],
        alertRef: [globalAlertRef],
        alertHeight: [setAlertHeight],
        securityTips: [showTips, setShowTips],
        promoBanner: [showBanner, setBanner],
        // alertState: [showAlert, setShowAlert]
      }}
    >
      <div className="App">
        <SecurityTips />
        <PromotionalBanner />
        <GlobalAlert />
        {/* <BrowserRouter> */}
        <MainHeader />
        <Routes>
          <Route
            exact
            path="/"
            element={<Home sectionHeight={alertHeight} />}
          />
          {/* about us */}
          <Route path="/about" element={<About />} />
          <Route path="/news/" element={<ListNews />} />
          <Route path="/news/:slug" element={<ViewNews />} />
          <Route path="/news/promotion" element={<PromotionNews />} />

          {/* <Route path="/about/corporate-info/overview" element={<Overview />} /> */}
          <Route path="/about/corporate-info/our-values" element={<OurValues />} />
          {/* <Route
            path="/about/corporate-info/our-background"
            element={<OurBackground />}
          /> */}
          <Route
            path="/about/corporate-governance/whistleblow"
            element={<Whistleblow />}
          />
          <Route
            path="/about/corporate-governance/disclosure"
            element={<Disclosure />}
          />
          <Route
            path="/about/corporate-governance/compliance"
            element={<Compliance />}
          />
          <Route
            path="/about/corporate-governance/fatca-crs"
            element={<FatcaCrs />}
          />
          <Route
            path="/about/corporate-profile/board-of-directors"
            element={<BoardOfDirectors />}
          />
          <Route
            path="/about/corporate-profile/shariah-board"
            element={<ShariahBoard />}
          />
          <Route
            path="/about/corporate-profile/executive-management"
            element={<ExecutiveManagement />}
          />

          <Route path="/financial-report" element={<FinancialReport />} />
          <Route
            path="/about/corporate-profile/view-profile"
            element={<ViewProfile />}
          />
          <Route path="/microsite" element={<Microsite />} />
          {/* personal */}
          <Route
            path="/personal/promotions/:slug"
            element={<PromotionsMain />}
          />
          <Route
            path="/personal/deposits/current-account"
            element={<CurrentAccount />}
          />
          <Route
            path="/personal/deposits/savings-account"
            element={<SavingsAccount />}
          />
          <Route
            path="/personal/deposits/commodity-murabahah-fc-ca-i"
            element={<Commodity />}
          />
          <Route
            path="/personal/deposits/commodity-murabahah-ca-i"
            element={<Commodity2 />}
          />
          <Route
            path="/personal/deposits/commodity-murabahah-sa-i"
            element={<Commodity3 />}
          />
          <Route
            path="/personal/deposits/commodity-murabahah-td-i"
            element={<Commodity4 />}
          />
          <Route path="/personal/affluent" element={<Affluent />} />
          {/* financing */}
          {/* <Route
            path="/personal/financing/personal-financing-td-i"
            element={<PersonalFinancingTD />}
          />
          <Route
            path="/personal/financing/personal-financing-i"
            element={<PersonalFinancing />}
          />
          <Route
            path="/personal/financing/personal-financing-i-ccsp-sd"
            element={<PersonalFinancingCCSP />}
          />
          <Route
            path="/personal/financing/personal-financing-i-ebs"
            element={<PersonalFinancingEBS />}
          />
          <Route
            path="/personal/financing/personal-financing-i-umrah"
            element={<PersonalFinancingUmrah />}
          /> */}
          <Route
            path="/personal/financing/home-financing-i"
            element={<PropertyFinancingHome />}
          />
          <Route
            path="/personal/financing/home-one-account"
            element={<PropertyFinancingHomeOne />}
          />
          <Route
            path="/personal/financing/business-financing"
            element={<BusinessFinancing />}
          />
          <Route
            path="/personal/financing/historical-trend"
            element={<HistoricalTrend />}
          />
          <Route
            path="/personal/financing/cashline-i"
            element={<CashlinePersonal />}
          />
          {/*  */}
          <Route path="/personal/cards/debit-card" element={<DebitCard />} />
          <Route path="/personal/cards/rafahia-card" element={<Rafahia />} />
          <Route path="/personal/wealth/gold-i" element={<Gold />} />
          <Route path="/personal/wealth/gold-invest" element={<GoldInvest />} />
          <Route path="/personal/wealth/unit-trust" element={<UnitTrust />} />
          <Route path="/personal/wealth/sinar-kasih" element={<SinarKasih />} />
          <Route
            path="/personal/wealth/sinar-link-aiman"
            element={<SinarLinkAiman />}
          />
          <Route
            path="/personal/wealth/sinar-baraqah"
            element={<SinarBaraqah />}
          />
          <Route
            path="/personal/wealth/sinar-health-plan"
            element={<SinarHealthPlan />}
          />
          <Route
            path="/personal/wealth/structured-product"
            element={<StructuredProduct />}
          />
          <Route
            path="/personal/wealth/will-writing"
            element={<WillWriting />}
          />
          <Route
            path="/personal/wealth/safe-deposit-box"
            element={<SafeDepositBox />}
          />
          <Route
            path="/personal/others/affluent-proposition"
            element={<AffluentProposition />}
          />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/career" element={<Career />} />
          {/* business */}
          <Route path="/business/treasury/deposit" element={<Deposit />} />
          <Route
            path="/business/treasury/foreign-exchange"
            element={<ForeignExchange />}
          />
          <Route
            path="/business/deposits/current-account"
            element={<CurrentAccountBiz />}
          />
          <Route
            path="/business/deposits/term-deposit-i"
            element={<TermDeposit />}
          />
          <Route
            path="/business/deposits/floating-rate-td"
            element={<FloatingRate />}
          />
          <Route
            path="/business/deposits/commodity-murabahah-biz"
            element={<CommodityMurabahahBiz />}
          />
          <Route
            path="/business/deposits/commodity-murabahah-biz-fc"
            element={<CommodityMurabahahBiz2 />}
          />
          <Route path="/business/global-markets" element={<GlobalMarkets />} />
          <Route path="/business/financing/cashline" element={<Cashline />} />
          <Route
            path="/business/financing/commodity-financing"
            element={<CommodityFinancing />}
          />
          <Route
            path="/business/financing/structured-commodity"
            element={<StructuredCommodity />}
          />
          <Route
            path="/business/financing/trade-financing/trade-finance"
            element={<TradeFinance />}
          />
          <Route
            path="/business/financing/trade-financing/letter-of-credit"
            element={<LetterCredit />}
          />
          <Route
            path="/business/financing/trade-financing/shipping-guarantee"
            element={<ShippingGuarantee />}
          />
          <Route
            path="/business/financing/trade-financing/bank-guarantee"
            element={<BankGuarantee />}
          />
          <Route
            path="/business/financing/trade-financing/trade-commodity"
            element={<TradeCommodity />}
          />
          <Route
            path="/business/financing/trade-financing/bill-collection"
            element={<BillCollection />}
          />
          <Route
            path="/business/financing/syndication-financing"
            element={<SyndicationFinancing />}
          />
          <Route
            path="/business/cash-management/alrajhi-cashbiz"
            element={<AlrajhiCashBiz />}
          />
          <Route
            path="/business/cash-management/e-payment"
            element={<EPayment />}
          />
          {/* Operations */}
          <Route
            path="/treat-customer-fairly-charter"
            element={<TreatCustomerFairlyCharter />}
          />
          <Route path="/client-charter" element={<ClientCharter />} />
          <Route path="/gold-price" element={<GoldPrice />} />
          <Route path="/unit-trust-price" element={<UnitTrustPrice />} />
          {/* general */}
          <Route path="tnc" element={<TermAndConditions />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="privacypolicy" element={<PrivacyPolicy />} />

          {/* Digital */}
          <Route
            path="/digital-banking-overview"
            element={<DigitalBankingOverview />}
          />
          <Route path="/digital/alrajhi-24seven" element={<VirtualBanking />} />

          <Route path="rize/personal" element={<Rize />} />
          <Route path="rize/support" element={<FAQ />} />
          <Route path="rize/promotions" element={<Promotions />} />
          <Route path="/rize/fraud-awareness" element={<FraudAwareness />} />

          <Route
            path="/important-notice-detail/:slug"
            exact
            element={<ImportantNoticeDetail />}
          />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route
            path="/foreign-exchange-rates"
            element={<ForeignExchangeRates />}
          />
          <Route
            path="/list-of-insured-deposits"
            element={<InsuredDeposits />}
          />
          <Route path="/negative-list" element={<NegativeList />} />
          <Route path="/auctions" element={<Auctions />} />
          <Route path="/e-application-form" element={<ApplicationForm />} />
          <Route path="/services/atm" element={<ATMServices />} />
          <Route path="/services/meps-atm" element={<MEPSATMServices />} />
          <Route path="/services/cheque-deposit" element={<ChequeDeposit />} />
          <Route
            path="/services/sms-notifications"
            element={<SMSNotificationAlerts />}
          />
          <Route
            path="/services/request-form"
            element={<ServiceRequestForm />}
          />
          <Route path="/important-notices" element={<ImportantNotices />} />
          <Route
            path="/images/gallery/Rize1_124.jpg"
            element={<img src={rize} width={"100%"} alt="rize header" />}
          />

          {/* Email verification - Rize */}
          <Route path="/email-verification/success" element={<Success />} />
          <Route path="/email-verification/failed" element={<Failed />} />
          <Route path="/email-verification/expired" element={<Expired />} />

          {/* <Route path="/microsite-test" element={<MicrositePF />} />
          <Route path="/microsite-umrah" element={<MicrositeUmrah />} />
          <Route path="/microsite-ccsp" element={<MicrositeCCSP />} />
          <Route path="/microsite-ebs" element={<MicrositeEBS />} />
          <Route path="/microsite-pftd" element={<MicrositePFTD />} /> */}

          <Route
            path="/personal/financing/personal-financing-td-i"
            element={<MicrositePFTD />}
          />
          <Route
            path="/personal/financing/personal-financing-i"
            element={<MicrositePF />}
          />
          <Route
            path="/personal/financing/personal-financing-i-ccsp-sd"
            element={<MicrositeCCSP />}
          />
          <Route
            path="/personal/financing/personal-financing-i-ebs"
            element={<MicrositeEBS />}
          />
          <Route
            path="/personal/financing/personal-financing-i-umrah"
            element={<MicrositeUmrah />}
          />

          <Route path="/important-notices" element={<ImportantNotices />} />
          <Route
            path="/images/gallery/Rize1_124.jpg"
            element={<img src={rize} width={"100%"} alt="rize header" />}
          />
          <Route path="/redirector" element={<QrRedirect />} />
          <Route
            path="*"
            element={
              <div>
                <Maintenance />
              </div>
            }
          />
        </Routes>

        <>
          <MainFooter />
          <SubFooter />
        </>
        {/* </BrowserRouter> */}
      </div>
    </TabContext.Provider>
  );
}

export default App;
